import * as React from 'react';
import './Spinner.scss';

export const Spinner = () => <div className='load-spinner'></div>;
